function initCollageHero(root) {
  if (!root) return;

  (function fixShopifyTopGap() {
    const wrapper = root.closest('[id^="shopify-section"]');
    if (!wrapper) return;
    const container = wrapper.parentElement;
    if (!container) return;

    function apply() {
      const padTop = parseFloat(getComputedStyle(container).paddingTop) || 0;
      const spacerId = `chf-spacer-${root.dataset.sectionId}`;
      let spacer = document.getElementById(spacerId);

      if (padTop > 0) {
        wrapper.style.marginTop = `${-padTop}px`;
        if (!spacer) {
          spacer = document.createElement('div');
          spacer.id = spacerId;
          container.insertBefore(spacer, wrapper.nextSibling);
        }
        spacer.style.height = `${padTop}px`;
      } else {
        wrapper.style.marginTop = '';
        if (spacer) spacer.remove();
      }
    }
    apply();
    window.addEventListener('resize', apply, { passive: true });
  })();

  function headerOverlap() {
    const header = document.querySelector('[data-header-sticky], .shopify-section-header');
    const announce = document.querySelector('.announcement-bar');
    const hRect = header ? header.getBoundingClientRect() : { height: 0 };
    const aRect = announce ? announce.getBoundingClientRect() : { height: 0 };
    return Math.round(hRect.height + aRect.height) || 0;
  }

  function applyOverlap() {
    const ov = headerOverlap();
    root.style.setProperty('--header-overlap', `${ov}px`);
    return ov;
  }

  function updateCentering() {
    const grid = root.querySelector('.chf__grid');
    if (!grid) return;
    const ov = applyOverlap();
    const viewportH = window.innerHeight;
    const available = viewportH - ov;
    const gridH = Math.ceil(grid.getBoundingClientRect().height);
    root.classList.toggle('is-tall', gridH > available - 2);
  }

  updateCentering();
  window.addEventListener('resize', updateCentering, { passive: true });
  window.addEventListener('scroll', updateCentering, { passive: true });

  const intervalMs = (parseInt(root.dataset.slideInterval, 10) * 1000) || 5000;
  const tileNodes = Array.from(root.querySelectorAll('.chf__tile[data-rotate="true"]'));

  const tiles = tileNodes.map(tile => {
    const imgs = Array.from(tile.querySelectorAll('img:not(.d-logo)'));
    // Знаходимо посилання-накладку
    const linkOverlay = tile.querySelector('.chf__link-overlay');
    
    const isRA = tile.classList.contains('chf__tile--ra');

    let frames = imgs, raSlides = [], caps = []; 

    if (isRA) {
      raSlides = Array.from(tile.querySelectorAll('.hero-slide'));
    }

    const isA = tile.classList.contains('chf__tile--a');
    if (isA) {
      const texts = imgs.map(img => (img.getAttribute('alt') || '').trim());
      if (texts.some(t => t.length > 0)) {
        const capRoot = document.createElement('div');
        capRoot.className = 'caption';
        texts.forEach(txt => {
          const span = document.createElement('span');
          span.className = 'caption-item';
          span.textContent = txt;
          capRoot.appendChild(span);
        });
        tile.appendChild(capRoot);
        caps = Array.from(capRoot.children);
      }
    }

    return { el: tile, frames, imgs, idx: 0, isA, isRA, caps, raSlides, linkOverlay };
  });

  function show(t, k) {
    t.frames.forEach(f => f.classList.remove('is-active'));
    // Активуємо поточну картинку
    const currentFrame = t.frames[k];
    if (currentFrame) {
      currentFrame.classList.add('is-active');
      
      // Оновлюємо посилання, якщо воно є
      if (t.linkOverlay) {
        const linkUrl = currentFrame.dataset.link;
        if (linkUrl) {
          t.linkOverlay.setAttribute('href', linkUrl);
          t.linkOverlay.style.pointerEvents = 'auto';
          t.linkOverlay.style.cursor = 'pointer';
        } else {
          t.linkOverlay.removeAttribute('href');
          t.linkOverlay.style.pointerEvents = 'none';
          t.linkOverlay.style.cursor = 'default';
        }
      }
    }

    if (t.isA && t.caps.length) {
      t.caps.forEach(c => c.classList.remove('is-active'));
      if (t.caps[k]) t.caps[k].classList.add('is-active');
    }
    
    if (t.isRA && t.raSlides.length) {
      t.raSlides.forEach(s => s.classList.remove('is-active'));
      if (t.raSlides[k % t.raSlides.length]) t.raSlides[k % t.raSlides.length].classList.add('is-active');
    }
  }

  // ============================================================================
  // SYNCHRONIZED ROTATION FIX
  // ============================================================================
  // Fixed: Changed from shared frame counter with modulo (causes drift when 
  // tiles have different image counts) to independent position tracking with
  // synchronized increments. Also handles missing images gracefully.
  // ============================================================================
  
  function startSynchronousLoop() {
    // Filter out tiles with missing/empty images to prevent sync issues
    tiles.forEach(t => {
      // Filter frames to only include valid images
      t.frames = t.frames.filter(f => {
        if (f.tagName !== 'IMG') return true;
        // Keep image if it has a valid src or data-src
        return f.src && f.src !== '' && f.src !== window.location.href;
      });
      
      if (t.frames.length) {
        t.idx = 0;
        show(t, 0);
      }
    });
    
    root.classList.add('ready');
    updateCentering();
    if (!tiles.length || intervalMs <= 0) return;

    // Synchronized rotation: all tiles increment position simultaneously
    setInterval(() => {
      tiles.forEach(t => {
        if (t.frames.length < 2) return; // Skip tiles with only 1 image
        
        // Move to next image independently (loops back to 0 at end)
        t.idx = (t.idx + 1) % t.frames.length;
        
        // Verify image is loaded before showing
        const node = t.frames[t.idx];
        if (node.tagName === 'IMG' && (!node.complete || node.naturalWidth === 0)) {
          // Image not loaded, skip this rotation for this tile
          // It will sync up on next interval
          return;
        }
        
        show(t, t.idx);
      });
    }, intervalMs);
  }

  const allImgs = tiles.flatMap(t => t.imgs);
  if (allImgs.length === 0) {
    startSynchronousLoop();
    return;
  }

  let loaded = 0;
  const onOneDone = () => {
    loaded++;
    if (loaded >= allImgs.length) startSynchronousLoop();
  };

  allImgs.forEach(img => {
    if (img.complete) {
      onOneDone();
    } else {
      img.addEventListener('load', onOneDone, { once: true });
      img.addEventListener('error', onOneDone, { once: true });
    }
  });

  setTimeout(() => { if (loaded < allImgs.length) startSynchronousLoop(); }, 3000);
}